// 添加趣味测试
import axios from 'axios';
import APIS from '../../apis';
import qs from 'qs';
import  {callbackHandler} from '../callbackHandler';

export default {
    state: {
    },
    mutations: {
    },
    getters: {},
    actions: {
        fungetDetail(context, params){
            return axios.get(APIS.fungetDetail, {
                params: params.params
            }).then(function (res) {
                callbackHandler(APIS.fungetDetail, res);
                return res.data;
            })
        },
        funquestion(context, params){
            return axios.get(APIS.funquestion, {
                params: params.params
            }).then(function (res) {
                callbackHandler(APIS.funquestion, res);
                return res.data;
            })
        },
        funsendAnswer(context, params){
            return axios.get(APIS.funsendAnswer, {
                params: params.params
            }).then(function (res) {
                callbackHandler(APIS.funsendAnswer, res);
                return res.data;
            })
        },
        fungetResult(context, params){
            return axios.get(APIS.fungetResult, {
                params: params.params
            }).then(function (res) {
                callbackHandler(APIS.fungetResult, res);
                return res.data;
            })
        },
        getWechatFunDetailRecommends(context, params){
            return axios.get(APIS.getWechatFunDetailRecommends, {
                params: params.params
            }).then(function (res) {
                callbackHandler(APIS.getWechatFunDetailRecommends, res);
                return res.data;
            })
        },
        getDailyFunTest(context, params){
            return axios.get(APIS.getDailyFunTest, {
                params: params.params
            }).then(function (res) {
                callbackHandler(APIS.getDailyFunTest, res);
                return res.data;
            })
        },
        getFunScaleDetailList(context, params){
            return axios.get(APIS.getFunScaleDetailList, {
                params: params.params
            }).then(function (res) {
                callbackHandler(APIS.getFunScaleDetailList, res);
                return res.data;
            })
        },
        getDailyFunTestList(context, params){
            return axios.get(APIS.getDailyFunTestList, {
                params: params.params
            }).then(function (res) {
                callbackHandler(APIS.getDailyFunTestList, res);
                return res.data;
            })
        },
        getFunTestList(context, params){
            return axios.get(APIS.funScales, {
                params: params.params
            }).then(function (res) {
                callbackHandler(APIS.funScales, res);
                return res.data;
            })
        },
        funsendAnswer(context, {env, params}={}){
            return axios.post(APIS.funsendAnswer, qs.stringify(params)).then((res)=>{
                return callbackHandler(APIS.funsendAnswer, res);
                return res.data;
            })
        },
        setFavoriteFunScale(context, params){
            return axios.get(APIS.setFavoriteFunScale, {
                params: params.params
            }).then(function (res) {
                callbackHandler(APIS.setFavoriteFunScale, res);
                return res.data;
            })
        },
        getFavoriteMessage(context, params){
            return axios.get(APIS.getFavoriteMessage, {
                params: params.params
            }).then(function (res) {
                callbackHandler(APIS.getFavoriteMessage, res);
                return res.data;
            })
        },
        getWechatFunResultRecommends(context, params){
            return axios.get(APIS.getWechatFunResultRecommends, {
                params: params.params
            }).then(function (res) {
                callbackHandler(APIS.getWechatFunResultRecommends, res);
                return res.data;
            })
        },
        getMyFavoriteFunScaleList(context, params){
            return axios.get(APIS.getMyFavoriteFunScaleList, {
                params: params.params
            }).then(function (res) {
                callbackHandler(APIS.getMyFavoriteFunScaleList, res);
                return res.data;
            })
        },
        getMyEvaluationList(context, params){
            return axios.get(APIS.getMyEvaluationList, {
                params: params.params
            }).then(function (res) {
                callbackHandler(APIS.getMyEvaluationList, res);
                return res.data;
            })
        },
        getPersonalStats(context, params){
            return axios.get(APIS.getPersonalStats, {
                params: params.params
            }).then(function (res) {
                callbackHandler(APIS.getPersonalStats, res);
                return res.data;
            })
        },
        
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/ceshi.js